import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import logo from '../../assets/img/logo.jpg';
import AuthService from "../../services/authService";

const pages = ['Home', 'Register', 'Download', 'Rankings', 'Market', 'Update', 'Schedule', 'Store'];
const pagesPath = ['/', '/user/register', '/downloads', '/ranks', '/marketplace', '/updates', '/schedules', 'https://discord.com/channels/1376412408045633576/1380598160900231331'];

const settingsLoggedIn = ['Change Password', 'Logout'];
const loggedInPages = ['/user/change-password', '/user/logout'];

const settingsLoggedOut = ['Login', 'Forgot password'];
const loggedOutPages = ['/user/login', '/user/forgot-password'];

function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const navigate = useNavigate();

    const handleOpenNavMenu = (e) => {
        setAnchorElNav(e.currentTarget);
    };
    const handleOpenUserMenu = (e) => {
        setAnchorElUser(e.currentTarget);
    };

    const handleCloseNavMenu = (page) => {
        setAnchorElNav(null);
        if (page) doNav(page);
    };

    const handleCloseUserMenu = (page) => {
        setAnchorElUser(null);
        if (page) doNav(page);
    };

    const doNav = (page) => {
        const index = pages.indexOf(page);
        if (index !== -1) {
            const url = pagesPath[index];
            if (url?.startsWith('https://')) {
                window.location.href = url;
            } else {
                navigate(url);
            }
            return;
        }

        const loggedInIndex = settingsLoggedIn.indexOf(page);
        if (loggedInIndex !== -1) {
            navigate(loggedInPages[loggedInIndex]);
            return;
        }

        const loggedOutIndex = settingsLoggedOut.indexOf(page);
        if (loggedOutIndex !== -1) {
            navigate(loggedOutPages[loggedOutIndex]);
        }
    };

    return (
        <AppBar position="static" sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
            <Container maxWidth="xl" sx={{ padding: '20px' }}>
                <Toolbar disableGutters>

                    {/* Mobile Menu */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton onClick={handleOpenNavMenu} color="inherit">
                            <MenuIcon sx={{ color: 'white' }} />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElNav}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            sx={{ display: { xs: 'block', md: 'none' } }}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page} onClick={() => handleCloseNavMenu(page)}>
                                    <Typography textAlign="center">{page}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>

                    {/* Logo */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <img
                            src={logo}
                            alt="logo"
                            style={{
                                borderRadius: '5px',
                                width: '80px',
                                marginRight: '20px',
                            }}
                        />
                    </Box>

                    {/* Desktop Navigation */}
                    <Box sx={{
                        flexGrow: 1,
                        justifyContent: 'center',
                        display: { xs: 'none', md: 'flex' },
                    }}>
                        {pages.map((page) => (
                            <Button
                                key={page}
                                onClick={() => handleCloseNavMenu(page)}
                                sx={{
                                    my: 2,
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    letterSpacing: 1.5,
                                    mx: 1,
                                    transition: 'all 0.3s ease',
                                    position: 'relative',
                                    '&:hover': {
                                        color: '#ffd786',
                                        textShadow: '0 0 10px rgba(255, 215, 134, 0.8)',
                                    },
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        bottom: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '2px',
                                        background:
                                            'linear-gradient(90deg, #ffd786 0%, #a6753a 100%)',
                                        transform: 'scaleX(0)',
                                        transformOrigin: 'left',
                                        transition: 'transform 0.3s ease',
                                    },
                                    '&:hover::after': {
                                        transform: 'scaleX(1)',
                                    },
                                }}
                            >
                                {page}
                            </Button>
                        ))}
                    </Box>

                    {/* User Avatar Menu */}
                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="User options">
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar src="" />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{ mt: '45px' }}
                            anchorEl={anchorElUser}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        >
                            {AuthService.isUserLoggedIn()
                                ? settingsLoggedIn.map((setting) => (
                                    <MenuItem key={setting} onClick={() => handleCloseUserMenu(setting)}>
                                        <Typography textAlign="center">{setting}</Typography>
                                    </MenuItem>
                                ))
                                : settingsLoggedOut.map((setting) => (
                                    <MenuItem key={setting} onClick={() => handleCloseUserMenu(setting)}>
                                        <Typography textAlign="center">{setting}</Typography>
                                    </MenuItem>
                                ))}
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default ResponsiveAppBar;
